export const toSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9_]/g, "")
    .toLowerCase();
};

export const sanitizeFontFamilyName = (s: string | null | undefined): string => {
  // This function can receive a single font family name or a font family name
  // and fallbacks, separated by commas. We need to split on any commas that may
  // be present in the passed in string.
  const fontFamilyNames = (s || "Untitled Sans")
    .split(",")
    .map((name) => name.trim())
    .map((name) =>
      name.replace(/^_*(.)|_+(.)/g, (s, c, d) => (c ? c.toUpperCase() : " " + d.toUpperCase()))
    );

  // Unquoted font family names with spaces can get tokenized oddly, which will cause them
  // to not get loaded correctly, so we need to wrap in quotes.
  return fontFamilyNames.map((name) => `"${name}"`).join(", ");
};
